
import * as THREE from "../../libs/three.js/build/three.module.js";
import { Utils } from "../utils.js";
import { ShowMode } from "../defines.js";

export class Profile extends THREE.Object3D {

	constructor() {
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;

		this.name = 'Profile_' + this.constructor.counter;
		this.points = [];
		this.spheres = [];
		this.edges = [];
		this.boxes = [];
		this.width = 1;
		this.height = 20;
		this._modifiable = true;

		this.sphereGeometry = new THREE.SphereGeometry(0.4, 10, 10);
		this.color = new THREE.Color(0xff0000);
		this.lineColor = new THREE.Color(0xff0000);
	}

	createSphereMaterial() {
		let sphereMaterial = new THREE.MeshLambertMaterial({
			//shading: THREE.SmoothShading,
			color: 0xff0000,
			depthTest: false,
			depthWrite: false
		}
		);

		return sphereMaterial;
	};

	getSegments() {
		let segments = [];

		for (let i = 0; i < this.points.length - 1; i++) {
			let start = this.points[i].clone();
			let end = this.points[i + 1].clone();
			segments.push({ start: start, end: end });
		}

		return segments;
	}

	getSegmentMatrices() {
		let segments = this.getSegments();
		let matrices = [];

		for (let segment of segments) {
			let { start, end } = segment;

			let box = new THREE.Object3D();

			let length = start.clone().setZ(0).distanceTo(end.clone().setZ(0));
			box.scale.set(length, 10000, this.width);
			box.up.set(0, 0, 1);

			let center = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
			let diff = new THREE.Vector3().subVectors(end, start);
			let target = new THREE.Vector3(diff.y, -diff.x, 0);

			box.position.set(0, 0, 0);
			box.lookAt(target);
			box.position.copy(center);

			box.updateMatrixWorld();
			matrices.push(box.matrixWorld);
		}

		return matrices;
	}

	addMarker(point) {
		this.points.push(point);

		let sphere = new THREE.Mesh(this.sphereGeometry, this.createSphereMaterial());

		this.add(sphere);
		this.spheres.push(sphere);

		// edges & boxes
		if (this.points.length > 1) {
			// 重构178 核心语法错误修复 Geometry废弃 改用 BufferGeometry
			// let lineGeometry = new THREE.Geometry();
			// lineGeometry.vertices.push(new THREE.Vector3(), new THREE.Vector3());
			// lineGeometry.colors.push(this.lineColor, this.lineColor, this.lineColor);
			let lineGeometry = new THREE.BufferGeometry();
			// 初始化两个顶点的位置数组
			const positions = new Float32Array([0, 0, 0, 0, 0, 0]);
			// 初始化顶点颜色数组（与 lineColor 匹配）
			const colors = new Float32Array([
				this.lineColor.r, this.lineColor.g, this.lineColor.b,
				this.lineColor.r, this.lineColor.g, this.lineColor.b
			]);
			lineGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
			lineGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

			// 重构178 THREE.VertexColors 已经移除
			let lineMaterial = new THREE.LineBasicMaterial({
				// vertexColors: THREE.VertexColors,
				vertexColors: 2,
				linewidth: 2,
				transparent: true,
				opacity: 0.4
			});
			lineMaterial.depthTest = false;
			let edge = new THREE.Line(lineGeometry, lineMaterial);
			edge.visible = false;

			this.add(edge);
			this.edges.push(edge);

			let boxGeometry = new THREE.BoxGeometry(1, 1, 1);
			let boxMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 0.2 });
			let box = new THREE.Mesh(boxGeometry, boxMaterial);
			box.visible = false;

			this.add(box);
			this.boxes.push(box);
		}

		{ // event listeners
			let drag = (e) => {
				let I = Utils.getMouseIntersection(
					e.drag.end,
					e.viewer.scene.getActiveCamera(),
					e.viewer);

				if (I) {
					let i = this.spheres.indexOf(e.drag.object);
					if (i !== -1) {
						this.setPosition(i, I.location);
						//this.dispatchEvent({
						//	'type': 'marker_moved',
						//	'profile': this,
						//	'index': i
						//});
					}
				}
			};

			let drop = e => {
				let i = this.spheres.indexOf(e.drag.object);
				if (i !== -1) {
					this.dispatchEvent({
						'type': 'marker_dropped',
						'profile': this,
						'index': i
					});
				}
			};

			let mouseover = (e) => e.object.material.emissive.setHex(0x888888);
			let mouseleave = (e) => e.object.material.emissive.setHex(0x000000);

			sphere.addEventListener('drag', drag);
			sphere.addEventListener('drop', drop);
			sphere.addEventListener('mouseover', mouseover);
			sphere.addEventListener('mouseleave', mouseleave);
		}

		let event = {
			type: 'marker_added',
			profile: this,
			sphere: sphere
		};
		this.dispatchEvent(event);

		this.setPosition(this.points.length - 1, point);
	}

	removeMarker(index) {
		this.points.splice(index, 1);

		this.remove(this.spheres[index]);

		let edgeIndex = (index === 0) ? 0 : (index - 1);
		this.remove(this.edges[edgeIndex]);
		this.edges.splice(edgeIndex, 1);
		this.remove(this.boxes[edgeIndex]);
		this.boxes.splice(edgeIndex, 1);

		this.spheres.splice(index, 1);

		this.update();

		this.dispatchEvent({
			'type': 'marker_removed',
			'profile': this
		});
	}

	setPosition(index, position) {
		let point = this.points[index];
		point.copy(position);

		let event = {
			type: 'marker_moved',
			profile: this,
			index: index,
			position: point.clone()
		};
		this.dispatchEvent(event);

		this.update();
	}

	setWidth(width) {
		this.width = width;

		let event = {
			type: 'width_changed',
			profile: this,
			width: width
		};
		this.dispatchEvent(event);

		this.update();
	}

	getWidth() {
		return this.width;
	}

	update() {
		if (this.points.length === 0) {
			return;
		} else if (this.points.length === 1) {
			let point = this.points[0];
			this.spheres[0].position.copy(point);

			return;
		}

		let min = this.points[0].clone();
		let max = this.points[0].clone();
		let centroid = new THREE.Vector3();
		let lastIndex = this.points.length - 1;
		for (let i = 0; i <= lastIndex; i++) {
			let point = this.points[i];
			let sphere = this.spheres[i];
			let leftIndex = (i === 0) ? lastIndex : i - 1;
			// let rightIndex = (i === lastIndex) ? 0 : i + 1;
			let leftVertex = this.points[leftIndex];
			// let rightVertex = this.points[rightIndex];
			let leftEdge = this.edges[leftIndex];
			let rightEdge = this.edges[i];
			let leftBox = this.boxes[leftIndex];
			// rightBox = this.boxes[i];

			// let leftEdgeLength = point.distanceTo(leftVertex);
			// let rightEdgeLength = point.distanceTo(rightVertex);
			// let leftEdgeCenter = new THREE.Vector3().addVectors(leftVertex, point).multiplyScalar(0.5);
			// let rightEdgeCenter = new THREE.Vector3().addVectors(point, rightVertex).multiplyScalar(0.5);

			sphere.position.copy(point);

			if (this._modifiable) {
				sphere.visible = true;
			} else {
				sphere.visible = false;
			}

			if (leftEdge) {
				// 重构178 核心语法错误修复 Geometry废弃 改用 BufferGeometry引起的使用问题
				// leftEdge.geometry.vertices[1].copy(point);
				// leftEdge.geometry.verticesNeedUpdate = true;
				const posAttr = leftEdge.geometry.getAttribute('position');
				posAttr.setXYZ(1, point.x, point.y, point.z); // 更新第二个顶点（索引1）
				posAttr.needsUpdate = true; // 标记属性更新

				leftEdge.geometry.computeBoundingSphere();
			}

			if (rightEdge) {
				// 重构178 核心语法错误修复 Geometry废弃 改用 BufferGeometry引起的使用问题
				// rightEdge.geometry.vertices[0].copy(point);
				// rightEdge.geometry.verticesNeedUpdate = true;
				const posAttr = rightEdge.geometry.getAttribute('position');
				posAttr.setXYZ(0, point.x, point.y, point.z); // 更新第一个顶点（索引0）
				posAttr.needsUpdate = true; // 标记属性更新

				rightEdge.geometry.computeBoundingSphere();
			}

			if (leftBox) {
				let start = leftVertex;
				let end = point;
				let length = start.clone().setZ(0).distanceTo(end.clone().setZ(0));
				leftBox.scale.set(length, 1000000, this.width);
				leftBox.up.set(0, 0, 1);

				let center = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
				let diff = new THREE.Vector3().subVectors(end, start);
				let target = new THREE.Vector3(diff.y, -diff.x, 0);

				leftBox.position.set(0, 0, 0);
				leftBox.lookAt(target);
				leftBox.position.copy(center);
			}

			centroid.add(point);
			min.min(point);
			max.max(point);
		}
		centroid.multiplyScalar(1 / this.points.length);

		for (let i = 0; i < this.boxes.length; i++) {
			let box = this.boxes[i];

			box.position.z = min.z + (max.z - min.z) / 2;
		}
	}

	raycast(raycaster, intersects) {
		for (let i = 0; i < this.points.length; i++) {
			let sphere = this.spheres[i];

			sphere.raycast(raycaster, intersects);
		}

		// recalculate distances because they are not necessarely correct
		// for scaled objects.
		// see https://github.com/mrdoob/three.js/issues/5827
		// TODO: remove this once the bug has been fixed
		for (let i = 0; i < intersects.length; i++) {
			let I = intersects[i];
			I.distance = raycaster.ray.origin.distanceTo(I.point);
		}
		intersects.sort(function (a, b) { return a.distance - b.distance; });
	};

	get modifiable() {
		return this._modifiable;
	}

	set modifiable(value) {
		this._modifiable = value;
		this.update();
	}

}

/**
 * 这个类暂时是未完成，且废弃的状态。
 * 因为当初做的时候想的是通过切面获取两点之间线在2D中穿过的点的数据。
 * 但是剖面延伸出来特定角度会多出很多超出线段的点。所以暂时换其他方案。
 * @class YDProfile
 */
export class YDProfile extends THREE.Object3D {
	/**
	 * @param {THREE.Camera} camera - 相机实例（需为PerspectiveCamera）
	 * @param {number} zScale - Z方向厚度
	 * @param {number} yScale - Y方向延伸长度
	 * @param {number} axesSize - 坐标轴尺寸
	 */
	constructor(camera, zScale = 0.01, yScale = 100000, axesSize = 10) {
		super();

		// 校验相机类型（仅支持透视相机，符合视觉透视逻辑）
		if (!(camera instanceof THREE.PerspectiveCamera)) {
			console.warn("仅支持PerspectiveCamera，将使用默认三维距离计算");
			this.usePerspectiveLogic = false;
		} else {
			this.usePerspectiveLogic = true;
		}

		this.constructor.counter = this.constructor.counter ?? 0;
		this.constructor.counter++;

		this.name = 'YDProfile_' + this.constructor.counter;
		this.points = [];
		this.spheres = [];
		this.edges = [];
		this.boxes = [];
		this.zScale = zScale;
		this.yScale = yScale;
		this._modifiable = true;
		this.camera = camera;
		this.axesSize = axesSize;

		this.sphereGeometry = new THREE.SphereGeometry(0.4, 10, 10);
		this.color = new THREE.Color(0x00ff00);
		this.lineColor = new THREE.Color(0x00ff00);
	}

	createSphereMaterial() {
		return new THREE.MeshLambertMaterial({
			color: this.color.getHex(),
			depthTest: false,
			depthWrite: false
		});
	}

	getSegments() {
		const segments = [];
		for (let i = 0; i < this.points.length - 1; i++) {
			segments.push({
				start: this.points[i].clone(),
				end: this.points[i + 1].clone()
			});
		}
		return segments;
	}

	/**
	 * 步骤1：将世界坐标点转换到相机局部坐标系（方便计算深度）
	 * @param {THREE.Vector3} worldPoint - 世界坐标点
	 * @returns {THREE.Vector3} 相机坐标系下的点（Z值为深度，负值表示在相机前方）
	 */
	worldToCameraPoint(worldPoint) {
		return new THREE.Vector3().copy(worldPoint)
			.applyMatrix4(this.camera.matrixWorldInverse); // 应用相机的逆变换矩阵
	}

	/**
	 * 步骤2：计算两点在近裁剪面上的投影及视觉距离
	 * @param {THREE.Vector3} p1 - 世界坐标点P1
	 * @param {THREE.Vector3} p2 - 世界坐标点P2
	 * @returns {Object} { distance: 近裁剪面视觉距离, p1Proj: P1投影点, p2Proj: P2投影点 }
	 */
	getNearPlaneDistance(p1, p2) {
		const camP1 = this.worldToCameraPoint(p1); // 相机坐标系下的P1
		const camP2 = this.worldToCameraPoint(p2); // 相机坐标系下的P2
		const near = this.camera.near; // 相机近裁剪面距离（正值）

		// 近裁剪面在相机坐标系中的Z值为 -near（相机前方）
		// 投影公式：近裁剪面上的点 = 原点点 × (-near / 原Z值)（相似三角形缩放）
		const scale1 = -near / camP1.z;
		const scale2 = -near / camP2.z;
		const p1Proj = new THREE.Vector3(camP1.x * scale1, camP1.y * scale1, -near);
		const p2Proj = new THREE.Vector3(camP2.x * scale2, camP2.y * scale2, -near);

		// 计算近裁剪面上两点的二维距离（视觉距离）
		return {
			distance: p1Proj.distanceTo(p2Proj),
			p1Proj,
			p2Proj
		};
	}

	/**
	 * 步骤3：将近裁剪面视觉距离转换为目标深度的三维距离
	 * @param {THREE.Vector3} p1 - 世界坐标点P1
	 * @param {THREE.Vector3} p2 - 世界坐标点P2
	 * @returns {number} 目标深度处的三维距离（用于scale x）
	 */
	getVisualMatched3DDistance(p1, p2) {
		if (!this.usePerspectiveLogic) {
			return p1.distanceTo(p2); // 非透视相机时返回原始距离
		}

		// 计算近裁剪面视觉距离
		const { distance: nearPlaneDist } = this.getNearPlaneDistance(p1, p2);
		// 计算P1/P2在相机坐标系中的平均深度（取绝对值，Z为负值）
		const camP1 = this.worldToCameraPoint(p1);
		const camP2 = this.worldToCameraPoint(p2);
		const avgDepth = (- (camP1.z + camP2.z)) / 2; // 平均深度（正值，相机到目标平面的距离）

		// 相似三角形原理：目标深度距离 = 近裁剪面距离 × (平均深度 / 近裁剪面距离)
		// 推导：近裁剪面距离/near = 目标距离/avgDepth → 目标距离 = 近裁剪面距离 × (avgDepth / near)
		const near = this.camera.near;
		return nearPlaneDist * (avgDepth / near);
	}

	buildRotationMatrix(lineVec, cameraVec) {
		const yAxis = cameraVec.clone().normalize();
		const lineNorm = lineVec.clone().normalize();
		const xAxis = lineNorm.sub(yAxis.clone().multiplyScalar(lineNorm.dot(yAxis))).normalize();

		if (xAxis.length() < 0.0001) {
			const fallbackX = new THREE.Vector3(1, 0, 0);
			this.xAxis = fallbackX.sub(yAxis.clone().multiplyScalar(fallbackX.dot(yAxis))).normalize();
		}

		const zAxis = new THREE.Vector3().crossVectors(xAxis, yAxis).normalize();

		const rotMatrix = new THREE.Matrix4();
		rotMatrix.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		const quat = new THREE.Quaternion();
		quat.setFromRotationMatrix(rotMatrix);
		return quat;
	}

	getSegmentMatrices() {
		const segments = this.getSegments();
		const matrices = [];

		for (const seg of segments) {
			const { start, end } = seg;
			const box = new THREE.Object3D();

			// 核心：使用视觉匹配的三维距离作为X轴尺度
			const lineLength = this.getVisualMatched3DDistance(start, end);
			box.scale.set(lineLength, this.yScale, this.zScale);

			const center = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
			box.position.copy(center);

			const lineVec = new THREE.Vector3().subVectors(end, start);
			const cameraVec = new THREE.Vector3().subVectors(this.camera.position, center);
			box.quaternion.copy(this.buildRotationMatrix(lineVec, cameraVec));

			box.updateMatrixWorld();
			matrices.push(box.matrixWorld);
		}

		return matrices;
	}

	addMarker(point) {
		this.points.push(point);

		const sphere = new THREE.Mesh(this.sphereGeometry, this.createSphereMaterial());
		this.add(sphere);
		this.spheres.push(sphere);

		if (this.points.length > 1) {
			const lineGeo = new THREE.BufferGeometry().setFromPoints([
				this.points[this.points.length - 2],
				point
			]);
			const lineMat = new THREE.LineBasicMaterial({
				color: this.lineColor,
				linewidth: 2,
				transparent: true,
				opacity: 0.4,
				depthTest: false
			});
			const edge = new THREE.Line(lineGeo, lineMat);
			edge.visible = true;

			this.add(edge);
			this.edges.push(edge);


			const boxGeo = new THREE.BoxGeometry(1, 1, 1);
			const boxMat = new THREE.MeshBasicMaterial({
				color: this.color.getHex(),
				transparent: true,
				opacity: 0.2,
				side: THREE.DoubleSide
			});
			const box = new THREE.Mesh(boxGeo, boxMat);
			box.visible = true;

			this.add(box);
			this.boxes.push(box);
		}

		const bindEvents = (obj) => {
			const drag = (e) => {
				let I = Utils.getMouseIntersection(
					e.drag.end,
					e.viewer.scene.getActiveCamera(),
					e.viewer);

				if (I) {
					let i = this.spheres.indexOf(e.drag.object);
					if (i !== -1) {
						this.setPosition(i, I.location);
					}
				}
			};

			const drop = (e) => {
				const idx = this.spheres.indexOf(obj);
				if (idx !== -1) {
					this.dispatchEvent({ type: 'marker_dropped', profile: this, index: idx });
				}
			};

			const mouseover = (e) => e.object.material.emissive.setHex(0x888888);
			const mouseleave = (e) => e.object.material.emissive.setHex(0x000000);

			obj.addEventListener('drag', drag);
			obj.addEventListener('drop', drop);
			obj.addEventListener('mouseover', mouseover);
			obj.addEventListener('mouseleave', mouseleave);
		};
		bindEvents(sphere);

		this.dispatchEvent({ type: 'marker_added', profile: this, sphere });
		this.setPosition(this.points.length - 1, point);
	}

	removeMarker(index) {
		if (index < 0 || index >= this.points.length) return;

		this.points.splice(index, 1);
		this.remove(this.spheres[index]);
		this.spheres.splice(index, 1);

		const edgeIdx = index === 0 ? 0 : index - 1;
		this.remove(this.edges[edgeIdx]);
		this.edges.splice(edgeIdx, 1);

		this.remove(this.boxes[edgeIdx]);
		this.boxes.splice(edgeIdx, 1);

		this.update();
		this.dispatchEvent({ type: 'marker_removed', profile: this });
	}

	setPosition(index, position) {
		if (index < 0 || index >= this.points.length) return;

		this.points[index].copy(position);
		this.dispatchEvent({
			type: 'marker_moved',
			profile: this,
			index,
			position: position.clone()
		});

		this.update();
	}

	// 其他方法（setZScale、setYScale、toggleAxes等）保持不变...

	update() {
		if (this.points.length === 0) return;

		if (this.points.length === 1) {
			this.spheres[0].position.copy(this.points[0]);
			return;
		}

		for (let i = 0; i < this.points.length; i++) {
			const point = this.points[i];
			this.spheres[i].position.copy(point);
			this.spheres[i].visible = this._modifiable;

			if (i > 0) {
				const start = this.points[i - 1];
				const end = point;
				const edge = this.edges[i - 1];
				const box = this.boxes[i - 1];

				edge.geometry.setFromPoints([start, end]);

				// 使用视觉匹配的三维距离更新X轴尺度
				const lineLen = this.getVisualMatched3DDistance(start, end);
				box.scale.set(lineLen, this.yScale, this.zScale);

				const center = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);
				box.position.copy(center);

				const lineVec = new THREE.Vector3().subVectors(end, start);
				const cameraVec = new THREE.Vector3().subVectors(this.camera.position, center);
				box.quaternion.copy(this.buildRotationMatrix(lineVec, cameraVec));
			}
		}
	}

	raycast(raycaster, intersects) {
		this.spheres.forEach(s => s.raycast(raycaster, intersects));
		intersects.sort((a, b) => a.distance - b.distance);
	}

	get modifiable() {
		return this._modifiable;
	}

	set modifiable(value) {
		this._modifiable = value;
		this.update();
	}
}